<template>
  <div ref="avatarroot">
    <div
      v-if="value"
      class="group relative bg-cover w-10 h-10 bg-primary-core border border-white-50% flex items-center justify-center rounded-lg"
      :style="{
        'background-color': stringToColor(value.name, 60, 40)
      }"
    >
      <img
        v-if="profileImageUri"
        :src="profileImageUri"
        class="w-11 h-11 object-cover border border-white-10% rounded-lg"
      />
      <span class="text-white text-22 font-semibold" v-else>
        {{ value.initials }}
      </span>

      <InfoTooltip v-if="value.showTooltip" :value="value.name"></InfoTooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: "SectionAvatar",

  props: ["section", "tooltip", "autoloadProfilePhoto"],
  data() {
    return {
      value: null,
      profileImageUri: null
    };
  },

  mounted() {
    const val = {};
    if (this.section.name) {
      val.name = this.section.name;
      val.initials = this.section.name.substring(0, 2);
    }

    if (this.section.extSysApiSectionId) {
      val.extSysApiSectionId = this.section.extSysApiSectionId;
    }

    if (this.tooltip) {
      val.tooltip = true;
    } else {
      val.tooltip = false;
    }

    this.value = val;

    if (this.autoloadProfilePhoto) {
      this.setupLoadPhotoObserver();
    }
  },

  methods: {
    stringToColor(str, saturation, lightness) {
      var hash = 0;
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }

      var h = hash % 360;
      return "hsl(" + h + ", " + saturation + "%, " + lightness + "%)";
    },

    setupLoadPhotoObserver() {
      if (!this.value.extSysApiSectionId) {
        return;
      }
      const options = {
        root: null,
        threshold: "0"
      };

      const observer = new IntersectionObserver(([elm]) => {
        if (elm.isIntersecting) {
          this.$store.dispatch("sections/sectionsLoadProfilePicture", this.value.extSysApiSectionId).then(result => {
            this.profileImageUri = result;
          });
          observer.unobserve(this.$refs["avatarroot"]);
        }
      }, options);

      observer.observe(this.$refs["avatarroot"]);
    }
  },
  components: {
    InfoTooltip: () => import("@/components/Shared/InfoTooltip")
  }
};
</script>

<style scoped>
img {
  max-width: 2.75rem;
  max-height: 2.75rem;
}
</style>
